import { render, staticRenderFns } from "./CreateEmployeeSidebar.vue?vue&type=template&id=654f4949"
import script from "./CreateEmployeeSidebar.vue?vue&type=script&lang=js"
export * from "./CreateEmployeeSidebar.vue?vue&type=script&lang=js"
import style0 from "./CreateEmployeeSidebar.vue?vue&type=style&index=0&id=654f4949&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports